import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TextareaModule } from "primeng/textarea";
import { InputNumberModule } from "primeng/inputnumber";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { SliderModule } from "primeng/slider";
import { TableModule } from "primeng/table";
import { AccordionModule } from "primeng/accordion";
import { TabViewModule } from "primeng/tabview";
import { DialogModule } from "primeng/dialog";
import { ToastModule } from "primeng/toast";
import { MessagesModule } from "primeng/messages";
import { ProgressBarModule } from "primeng/progressbar";
import { TooltipModule } from "primeng/tooltip";
import { ChipsModule } from "primeng/chips";
import { BadgeModule } from "primeng/badge";
import { PaginatorModule } from "primeng/paginator";

import { MessageService } from "primeng/api";

import { FormsModule } from "@angular/forms";

import { palette } from "@primeng/themes";
import { PaginatorState } from "primeng/paginator";

@Component({
	selector: "app-test",
	templateUrl: "./test.component.html",
	styleUrls: ["./test.component.scss"],
	imports: [
		CommonModule,
		FormsModule,
		ButtonModule,
		InputTextModule,
		TextareaModule,
		InputNumberModule,
		CalendarModule,
		DropdownModule,
		MultiSelectModule,
		CheckboxModule,
		RadioButtonModule,
		SliderModule,
		TableModule,
		AccordionModule,
		TabViewModule,
		DialogModule,
		ToastModule,
		MessagesModule,
		ProgressBarModule,
		TooltipModule,
		ChipsModule,
		BadgeModule,
		PaginatorModule,
	],
	providers: [MessageService],
	standalone: true,
})
export class TestComponent implements OnInit {
	ngOnInit(): void {}
	value: number = 0;
	checked: boolean = false;
	selectedDate: Date | null = null;
	selectedCity: string = "";
	selectedCities: string[] = [];
	radioValue: string = "";
	sliderValue: number = 50;
	showDialog: boolean = false;
	chips: string[] = [];
	progress: number = 70;
	msgs = [{ severity: "info", summary: "Info", detail: "Nachricht Beispiel" }];

	cities = [
		{ label: "New York", value: "New York" },
		{ label: "Rome", value: "Rome" },
		{ label: "London", value: "London" },
		{ label: "Istanbul", value: "Istanbul" },
	];

	products = [
		{ name: "Produkt A", price: "10€" },
		{ name: "Produkt B", price: "20€" },
	];

	aeotec = Object.keys(palette("{aeotec}"));

	constructor(private messageService: MessageService) {}

	showToast() {
		this.messageService.add({
			severity: "success",
			summary: "Erfolg",
			detail: "Dies ist ein Toast!",
		});
	}

	first: number = 0;

	rows: number = 10;

	onPageChange(event: PaginatorState) {
		this.first = event.first ?? 0;
		this.rows = event.rows ?? 10;
	}
}
